import { createRouter, createWebHistory } from 'vue-router'
import authService from '../authService'
import userService from '../shared/services/userService'
import store from '../store'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // Public Profile with custom layout (no default header)
    {
      path: '/public/:uuid',
      component: () => import('@/layouts/public_profile_base.vue'),
      children: [
        {
          name: 'Public Profile',
          path: '',
          component: () => import('@/views/pages/PublicProfileNew.vue'),
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/layouts/empty_base.vue'),
      children: [
        {
          name: 'HomePage',
          path: '',
          component: () => import('@/views/pages/Login.vue'),
        },
        {
          name: 'Login',
          path: 'login',
          component: () => import('@/views/pages/Login.vue'),
        },
        {
          name: 'Register',
          path: 'register',
          component: () => import('@/views/pages/Register.vue'),
        },
        {
          name: 'Confirm password reset',
          path: 'confirm-password-reset/:resetId',
          component: () => import('@/views/pages/ConfirmPasswordReset.vue'),
        },
        {
          name: 'Public Profile Legacy',
          path: 'public-legacy/:uuid',
          component: () => import('@/views/pages/PublicProfile.vue'),
        },
        {
          name: 'Accept company invite',
          path: 'acceptCompanyInvitation/:token',
          component: () => import('@/views/pages/CompanyInvitation.vue'),
        },
        {
          name: 'EFK position',
          path: 'efkPosition/:userId/:action',
          component: () => import('@/views/pages/EFKPosition.vue'),
          props: true,
        },
        {
          name: 'ForbiddenPage',
          path: 'forbidden',
          component: () => import('@/views/pages/Forbidden.vue'),
        },
      ],
    },
    {
      path: '/app',
      component: () => import('@/layouts/app_base.vue'),
      children: [
        {
          name: 'dashboard',
          path: '',
          component: () => import('@/views/app/Dashboard.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'user-profile',
          path: 'user',
          component: () => import('@/views/app/user/UserProfile.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'my-documents',
          path: 'my-documents',
          component: () => import('@/views/app/user/my-documents/MyDocuments.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'my-documents-academy',
          path: 'my-documents/academy/:enrollmentId',
          component: () => import('@/views/app/user/my-documents/AcademyCourseDocuments.vue'),
          meta: { authorities: ['admin'] },
        },
        {
          name: 'change-password',
          path: 'change-password',
          component: () => import('@/views/app/user/ChangePassword.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'edit-user-profile',
          path: 'users/:uuid',
          component: () => import('@/views/app/user/UserProfile.vue'),
          meta: { authorities: ['admin'] },
        },
        {
          name: 'edit-user-profile-admin',
          path: 'user/:uuid',
          component: () => import('@/views/app/user/UserProfile.vue'),
          meta: { authorities: ['admin'] },
        },
        {
          name: 'users',
          path: 'users',
          component: () => import('@/views/app/user/DataTables.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'coworker',
          path: 'coworker',
          component: () => import('@/views/app/company/CoworkerTable.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'coworker-profile',
          path: 'coworker/:uuid',
          component: () => import('@/views/app/company/CoworkerProfile.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'companies',
          path: 'companies',
          component: () => import('@/views/app/company/CompanyDataTables.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'certification-authorities',
          path: 'certification-authorities',
          component: () => import('@/views/app/certificationAuthority/CertificationAuthoritiesTable.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'certification-authority',
          path: 'certification-authority',
          component: () => import('@/views/app/certificationAuthority/CertificationAuthorityProfile.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'certification-authority-admin',
          path: 'certification-authorities/:id',
          component: () => import('@/views/app/certificationAuthority/CertificationAuthorityProfile.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'certificates',
          path: 'certificates',
          component: () => import('@/views/app/certificate/CertificatesTable.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'courses',
          path: 'courses',
          component: () => import('@/views/app/certificationAuthority/courses/CourseComponent.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'certificate',
          path: 'certificate/new',
          component: () => import('@/views/app/certificate/CertificateWizard.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'company-profile',
          path: 'company-profile',
          component: () => import('@/views/app/company/CompanyProfile.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'company-profile-admin',
          path: 'companies/:id',
          component: () => import('@/views/app/company/CompanyProfile.vue'),
          meta: { authorities: ['admin'] },
        },
        {
          name: 'my-vehicles',
          path: 'company-vehicles',
          component: () => import('@/views/app/vehicle/CompanyVehiclesTable.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'my-vehicle',
          path: 'company-vehicles/:id',
          component: () => import('@/views/app/vehicle/CompanyVehiclesTable.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'assets',
          path: 'company-assets',
          component: () => import('@/views/app/asset/CompanyAssetsTable.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'asset',
          path: 'company-assets/:id',
          component: () => import('@/views/app/asset/CompanyAssetsTable.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          path: 'reports',
          meta: { authorities: ['user', 'admin'] },
          children: [
            {
              name: 'protocols',
              path: '',
              component: () => import('@/views/app/report/ReportsTable.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
            {
              name: 'new-report-no-id',
              path: 'new',
              component: () => import('@/views/app/report/ReportWizard.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
            {
              name: 'report',
              path: ':rid',
              component: () => import('@/views/app/report/ReportsTable.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
            {
              name: 'new-report',
              path: 'new/:companyVehicleId',
              component: () => import('@/views/app/report/ReportWizard.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
          ],
        },
        {
          path: 'checklists',
          meta: { authorities: ['user', 'admin'] },
          children: [
            {
              name: 'checklists',
              path: '',
              component: () => import('@/views/app/report/checklist/ChecklistTable.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
            {
              name: 'new-checklist',
              path: 'new',
              component: () => import('@/views/app/report/checklist/ChecklistWizard.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
            {
              name: 'view-checklist',
              path: ':cid',
              component: () => import('@/views/app/report/checklist/ChecklistTable.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
          ],
        },
        {
          path: 'manage',
          meta: { authorities: ['user', 'admin'] },
          children: [
            {
              name: 'manage',
              path: '',
              component: () => import('@/views/app/report/manage/Manage.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
            {
              name: 'edit-report-template',
              path: 'edit/:id',
              component: () => import('@/views/app/report/manage/ReportTemplateWizard.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
          ],
        },
        {
          name: 'manage-global',
          path: 'manage-global',
          component: () => import('@/views/app/report/manage/Manage.vue'),
          props: { global: true },
          meta: { authorities: ['admin'] },
        },
        {
          path: 'vehicle',
          meta: { authorities: ['user', 'admin'] },
          children: [
            {
              name: 'vehicles',
              path: '',
              component: () => import('@/views/app/vehicle/VehiclesTables.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
            {
              name: 'vehicle-details',
              path: ':id',
              component: () => import('@/views/app/vehicle/VehicleDetails.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
            {
              name: 'haynes-pro-details',
              path: 'haynes-pro-details',
              component: () => import('@/views/app/vehicle/HaynesProVehicleDetails.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
          ],
        },
        {
          path: 'vehicles',
          meta: { authorities: ['user', 'admin'] },
          children: [
            {
              name: 'vehicles-admin',
              path: '',
              component: () => import('@/views/app/vehicle/VehiclesTables.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
            {
              name: 'vehicle-details-admin',
              path: ':id',
              component: () => import('@/views/app/vehicle/VehicleDetails.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
            {
              name: 'haynes-pro-details-admin',
              path: 'haynes-pro-details',
              component: () => import('@/views/app/vehicle/HaynesProVehicleDetails.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
          ],
        },
        {
          name: 'local-storage-reset',
          path: 'local-storage-reset',
          component: () => import('@/views/app/LocalStorageReset.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'all-reports',
          path: 'all-reports',
          component: () => import('@/views/app/report/ReportsTable.vue'),
          meta: { authorities: ['admin'] },
        },
        {
          name: 'all-checklists',
          path: 'all-checklists',
          component: () => import('@/views/app/report/checklist/ChecklistTable.vue'),
          meta: { authorities: ['admin'] },
        },
        {
          name: 'all-assets',
          path: 'all-assets',
          component: () => import('@/views/app/asset/AllCompanyAssetsTable.vue'),
          meta: { authorities: ['admin'] },
        },
        {
          name: 'asset-types',
          path: 'asset-types',
          component: () => import('@/views/app/assetType/AssetTypesTable.vue'),
          meta: { authorities: ['admin'] },
        },
        {
          name: 'global-template-authors',
          path: 'global-template-authors',
          component: () => import('@/views/app/user/GlobalTemplateAuthors.vue'),
          meta: { authorities: ['admin'] },
        },
        {
          name: 'gtp-classes',
          path: 'gtp-classes',
          component: () => import('@/views/app/gtpClass/GtpClassesTable.vue'),
          meta: { authorities: ['admin'] },
        },
        {
          name: 'info-signs',
          path: 'signs',
          component: () => import('@/views/app/Signs.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          path: 'forum',
          meta: { authorities: ['user', 'admin'] },
          children: [
            {
              name: 'forum',
              path: '',
              component: () => import('@/views/app/forum/ForumTable.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
            {
              name: 'topic',
              path: ':id',
              component: () => import('@/views/app/forum/ForumTopic.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
          ],
        },
        {
          path: 'course',
          meta: { authorities: ['user', 'admin'] },
          children: [
            {
              name: 'join-course',
              path: 'join-course',
              component: () => import('@/views/app/certificationAuthority/courses/JoinCourse.vue'),
              meta: { authorities: ['user', 'admin'] },
            },
            {
              name: 'edit-course',
              path: 'edit-course',
              component: () => import('@/views/app/certificationAuthority/courses/EditCourse.vue'),
              meta: {
                authorities: ['user', 'admin'],
                parent: 'certification-authority',
              },
            },
          ],
        },
        {
          path: 'academy',
          meta: { authorities: ['admin'] },
          children: [
            {
              path: 'courses',
              meta: { authorities: ['admin'] },
              children: [
                {
                  path: '',
                  name: 'course.courses',
                  meta: { authorities: ['admin'] },
                  component: () => import('@/views/app/academy/Courses.vue'),
                },
                {
                  path: ':id',
                  name: 'course.booking',
                  meta: { authorities: ['admin'] },
                  component: () => import('@/views/app/academy/courses/Details.vue'),
                },
                {
                  path: ':id/checkout',
                  name: 'course.checkout',
                  meta: { authorities: ['admin'] },
                  component: () => import('@/views/app/academy/courses/Checkout.vue'),
                },
              ],
            },
            {
              path: 'my-courses',
              children: [
                {
                  path: '',
                  name: 'course.my-courses',
                  meta: { authorities: ['admin'] },
                  component: () => import('@/views/app/academy/MyCourses.vue'),
                },
                {
                  path: ':id',
                  name: 'course.my-courses-view',
                  meta: { authorities: ['admin'] },
                  component: () => import('@/views/app/academy/my-courses/Overview.vue'),
                },
                {
                  path: ':id/learn',
                  name: 'course.learn',
                  meta: { authorities: ['admin'] },
                  component: () => import('@/views/app/academy/my-courses/Learn.vue'),
                },
                {
                  path: ':enrollmentId/exam',
                  name: 'course.exam',
                  meta: { authorities: ['admin'] },
                  component: () => import('@/views/app/academy/my-courses/Exam.vue'),
                },
              ],
            },
            {
              path: 'my-orders',
              name: 'academy.my-orders',
              meta: { authorities: ['admin'] },
              component: () => import('@/views/app/academy/MyOrders.vue'),
            },
            {
              path: 'administration',
              meta: { authorities: ['admin'] },
              children: [
                {
                  path: '',
                  name: 'academy.administration',
                  meta: { authorities: ['admin'] },
                  component: () => import('@/views/app/academy/AdministrationTable.vue'),
                },
                {
                  path: ':id',
                  name: 'academy.edit-course',
                  meta: { authorities: ['admin'] },
                  component: () => import('@/views/app/academy/AdministrationEdit.vue'),
                },
                {
                  path: ':id/course/:courseId',
                  name: 'course.edit-content',
                  meta: { authorities: ['admin'] },
                  component: () => import('@/views/app/academy/CourseContentEdit.vue'),
                },
              ],
            },
          ],
        },
        {
          path: 'order',
          meta: { authorities: ['user', 'admin'] },
          children: [
            {
              path: 'completed',
              name: 'order.page-title',
              component: () => import('@/views/app/order/completed.vue'),
            },
          ],
        },
      ],
    },
    {
      path: '/pdf',
      component: () => import('@/layouts/pdf_base.vue'),
      children: [
        {
          name: 'report-pdf',
          path: 'report/:rid',
          component: () => import('@/views/pdf/ReportPdfDetails.vue'),
        },
        {
          name: 'certificate-pdf',
          path: 'certificate/:id',
          component: () => import('@/views/pdf/CertificatePdf.vue'),
        },
        {
          name: 'exam-result-pdf',
          path: 'exam-attempt/:id',
          component: () => import('@/views/pdf/ExamResultPdf.vue'),
        },
        {
          name: 'webviewer-training-data',
          path: 'webviewer/:id',
          component: () => import('@/views/pdf/WebViewer.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'webviewer',
          path: 'webviewer/doc/:id',
          component: () => import('@/views/pdf/WebViewer.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'webviewer-course-document',
          path: 'webviewer/course-document/:id',
          component: () => import('@/views/pdf/WebViewer.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
        {
          name: 'sign',
          path: 'sign',
          component: () => import('@/views/pdf/Sign.vue'),
          meta: { authorities: ['user', 'admin'] },
        },
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      component: () => import('@/layouts/empty_base.vue'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error.vue'),
        },
      ],
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  if (!to.matched.length) {
    next('/404')
  }

  await userService.getMyself()

  if (store.getters.authenticated) {
    if (to.path === '/' || to.path.includes('/login') || to.path.includes('/register')) {
      next('/app')
    }
  }

  if (to.meta && to.meta.authorities && to.meta.authorities) {
    const res = await authService.hasAnyRole(to.meta.authorities)
    if (!res) {
      if (authService.userIdentity) {
        next('/forbidden')
      } else {
        // If trying to access join-course, preserve the course ID
        if (to.name === 'join-course' && to.query.id) {
          next({
            path: '/login',
            query: { id: to.query.id },
          })
        } else {
          next('/login')
        }
      }
    } else {
      next()
    }
  } else {
    // no authorities, so just proceed
    next()
  }
})

export default router
